<div
  class="modal-wrapper"
  role="dialog"
  aria-modal="true"
  data-cy="optins_dialog"
  [style.backgroundColor]="config.backgroundColor"
>
  <div class="modal-content">
    <div
      id="dialog-title"
      class="modal-title"
      [style]="{
        color: config.title.color,
        fontFamily: config.title.fontFamily,
      }"
      [innerHTML]="config.title.label | safe"
    ></div>

    @if (!!config.subtitle) {
      <div
        class="modal-subtitle"
        [style]="{
          color: config.subtitle.color,
          fontFamily: config.subtitle.fontFamily,
        }"
        [innerHTML]="config.subtitle.label | safe"
      ></div>
    }

    <div
      id="dialog-subtitle"
      class="modal-body"
      data-cy="last_selection_dialog_content"
      [style]="{
        color: config.body.color,
        fontFamily: config.body.fontFamily,
      }"
      [innerHTML]="config.body.label | safe"
    ></div>

    <form class="modal-checkbox" [formGroup]="optinsForm">
      <b2c-checkbox
        data-cy="optins_checkbox"
        formControlName="optin"
        [label]="config.checkbox.label"
      />
      @if (displayErrorMsg()) {
        <div class="error-message" data-cy="error_message">
          {{ config.checkbox.errorMessage }}
        </div>
      }
    </form>

    <div class="modal-buttons">
      <b2c-button
        type="button"
        [attr.aria-label]="config.actionButtons.confirmButton.ariaLabel"
        [title]="config.actionButtons.confirmButton.ariaLabel"
        class="close-btn"
        data-cy="confirmation_btn"
        (click)="sendOptinAndSelectChallenge()"
        [styles]="{
          color: config.actionButtons.confirmButton.textColor,
          fontFamily: config.actionButtons.confirmButton.fontFamily,
          borderRadius: config.actionButtons.confirmButton.borderRadius,
          backgroundColor: config.actionButtons.confirmButton.backgroundColor,
          borderColor:
            config.actionButtons.confirmButton.borderColor ||
            config.actionButtons.confirmButton.backgroundColor,
        }"
      >
        {{ config.actionButtons.confirmButton.label }}</b2c-button
      >
      <b2c-button
        type="button"
        [attr.aria-label]="closeButtonConfig.ariaLabel"
        [title]="closeButtonConfig.ariaLabel"
        class="close-btn"
        data-cy="close_btn"
        (click)="showConfirmationDialog()"
        [styles]="{
          color: closeButtonConfig.textColor,
          fontFamily: config.actionButtons.confirmButton.fontFamily,
          borderRadius: closeButtonConfig.borderRadius,
          backgroundColor: closeButtonConfig.backgroundColor,
          borderColor:
            closeButtonConfig.borderColor || closeButtonConfig.backgroundColor,
        }"
      >
        {{ closeButtonConfig.label }}</b2c-button
      >
    </div>
  </div>

  <div
    class="modal-footer"
    [innerHTML]="config.templateOptinsDetails | join | safe"
  ></div>
</div>
